// extracted by mini-css-extract-plugin
export default {"card":"card_card__iPtAn","image":"card_image__Hko09","activeCard":"card_activeCard__S5fNI","nextCard":"card_nextCard__v3r-A","prevCard":"card_prevCard__9NEUq"};